import React from 'react';

const footer = (props) => {
    return (
        <div id='footer' className='center'>
            <img id='footer_img' src={process.env.PUBLIC_URL + '/assets/introduction/logo2.png'} />
            Site designed, created and maintained by Abhinandan Saha.
        </div>
    )

}

export default footer;